angular.module("AccountingBoxApp").config(function($stateProvider) {
  $stateProvider
    .state("app.bookkeeper.vendors", {
      url: "/leveranciers",
      templateUrl: "app/bookkeeper/vendors/masterDetail/masterDetail.html",
      controller: "VendorsMasterDetailCtrl",
      controllerAs: "vmd",
      resolve: {
        vendors: function(Vendor) {
          return Vendor.find({ filter: { order: "name ASC", limit: 5 } })
            .$promise;
        }
      }
    })
    .state("app.bookkeeper.vendors.new", {
      url: "/nieuw",
      component: "vendorEdit",
      resolve: {
        vendor: function(Vendor) {
          var vendor = new Vendor();
          vendor.isNew = true;
          vendor.type = "specific";
          vendor.bankAccountNumbers = [""];
          return vendor;
        }
      }
    })
    .state("app.bookkeeper.vendors.edit", {
      url: "/:id/bewerk",
      component: "vendorEdit",
      resolve: {
        vendor: function($transition$, Vendor) {
          return Vendor.findById({
            id: $transition$.params().id,
            // filter: { include: ["purchases"] }
          }).$promise;
        }
      }
    });
});
